import { gql } from 'graphql-request'

export const GET_SALE_PRODUCTS_QUERY = gql`
  query getSaleProducts(
    $limit: Int
    $offset: Int
    $search: String
    $status: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $price_from: Int
    $price_to: Int
    $creator_nickname: String
    $creator_slug: [String!]
    $creator_id: bigint
  ) {
    products(
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
      where: {
        _and: [
          { status: { _eq: "active" } }
          { status: { _in: $status } }
          { visible: { _eq: "true" } }
          {
            creator: {
              id: { _eq: $creator_id }
              slug: { _in: $creator_slug }
              nickname: { _eq: $creator_nickname }
              account_status: { _eq: "active" }
              creator_category_id: { _in: $creator_categories }
              deleted: { _neq: true }
            }
          }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                    price_before_discount_subunit: { _neq: 0 }
                  }
                }
              }
              {
                price: {
                  price_subunit: { _gte: $price_from, _lte: $price_to }
                  price_before_discount_subunit: { _neq: 0 }
                }
              }
            ]
          }
          {
            product_categories: {
              product_category_id: { _in: $topic }
              _or: { product_category_id: { _in: $product_categories } }
            }
          }
          {
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      id
      slug
      name
      cover: main_photo_url
      created_at
      duration: duration_of_event
      type
      status
      embedded_link
      tags
      orders_count
      bestseller
      newness
      visible
      creator {
        id
        slug
        nickname
        avatar: avatar_link
      }
      categories: product_categories {
        id: product_category_id
        category: product_category {
          id
          name
        }
      }
      entries: product_contest_entries {
        id
        name
        price {
          value: price_subunit
          currency: price_currency
        }
      }
      price {
        currency: price_currency
        value: price_subunit
        price_before_discount: price_before_discount_subunit
      }
    }
  }
`

export const GET_SALE_PRODUCTS_COUNT_QUERY = gql`
  query getSaleProductsCount(
    $limit: Int
    $offset: Int
    $search: String
    $status: [String!]
    $type: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $price_from: Int
    $price_to: Int
    $creator_nickname: String
    $creator_slug: [String!]
    $creator_id: bigint
  ) {
    products_aggregate(
      limit: $limit
      offset: $offset
      order_by: { orders_count: desc }
      where: {
        _and: [
          { type: { _in: $type } }
          { status: { _eq: "active" } }
          { status: { _in: $status } }
          { visible: { _eq: "true" } }
          {
            creator: {
              id: { _eq: $creator_id }
              slug: { _in: $creator_slug }
              nickname: { _eq: $creator_nickname }
              account_status: { _eq: "active" }
              creator_category_id: { _in: $creator_categories }
              deleted: { _neq: true }
            }
          }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              }
              {
                price: {
                  price_before_discount_subunit: { _neq: 0 }
                  price_subunit: { _gte: $price_from, _lte: $price_to }
                }
              }
            ]
          }
          {
            product_categories: {
              product_category_id: { _in: $topic }
              _or: { product_category_id: { _in: $product_categories } }
            }
          }
          {
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export const GET_SALE_PRODUCTS_HIGHEST_PRICE = gql`
  query getSaleProductsHighestPrice(
    $search: String
    $status: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $price_from: Int
    $price_to: Int
    $type: [String!]
    $creator_nickname: String
    $creator_slug: [String!]
    $creator_id: bigint
  ) {
    products(
      limit: 5
      order_by: { price: { price_subunit: desc } }
      where: {
        _and: [
          { type: { _in: $type } }
          { status: { _eq: "active" } }
          { status: { _in: $status } }
          { visible: { _eq: "true" } }
          {
            creator: {
              id: { _eq: $creator_id }
              slug: { _in: $creator_slug }
              nickname: { _eq: $creator_nickname }
              account_status: { _eq: "active" }
              creator_category_id: { _in: $creator_categories }
              deleted: { _neq: true }
            }
          }
          { orders_count: { _gt: 0 } }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              }
              {
                price: {
                  price_subunit: { _gte: $price_from, _lte: $price_to }
                  price_before_discount_subunit: { _neq: 0 }
                }
              }
            ]
          }
          {
            product_categories: {
              product_category_id: { _in: $topic }
              _or: { product_category_id: { _in: $product_categories } }
            }
          }
          {
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      price {
        value: price_subunit
      }
    }
  }
`
